<nz-affix [nzOffsetTop]="0">
  <hx-breadcrumbs></hx-breadcrumbs>
  <nz-page-header nzBackIcon [nzGhost]="false">
    <nz-page-header-title>{{(isEdit ? 'action.edit' : 'action.create') | transloco}}</nz-page-header-title>
  </nz-page-header>
</nz-affix>
<nz-skeleton [nzActive]="true" [nzLoading]="isLoading.model">
  <form nz-form class="hx-form" [nzLayout]="'vertical'" [formGroup]="form" (ngSubmit)="submitForm()" *transloco="let tr; prefix: 'workflows'; scope: 'workflows'">
    <div nz-row [nzGutter]="8">
      <div nz-col class="hx-col-2">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.product')}}</nz-form-label>
          <nz-form-control>
            <hx-product-info-select formControlName="productInfoId" (selectChange)="onProductChanged($event)"></hx-product-info-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.net')}}</nz-form-label>
          <nz-form-control>
            <input nz-input formControlName="netAmount"/>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.gross')}}</nz-form-label>
          <nz-form-control>
            <input nz-input formControlName="grossAmount"/>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col>
        <nz-form-item>
          <nz-form-label>{{tr('form.servicePrice')}}</nz-form-label>
          <nz-form-control>
            <hx-unit-measure-select formControlName="toUnitOfMeasure" (selectChange)="onUomChanged($event)"></hx-unit-measure-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.coefficient')}}</nz-form-label>
          <nz-input-group [nzAddOnBefore]="'1' + productUomName + '='" [nzAddOnAfter]="uomName">
            <input type="text" nz-input formControlName="coefficient" />
          </nz-input-group>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.group')}}</nz-form-label>
          <nz-select formControlName="group">
            <nz-option [nzValue]="item" *ngFor="let item of numbersList" [nzLabel]="item"></nz-option>
          </nz-select>
        </nz-form-item>
      </div>
      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.priority')}}</nz-form-label>
          <nz-select formControlName="priority">
            <nz-option [nzValue]="item" *ngFor="let item of numbersList" [nzLabel]="item"></nz-option>
          </nz-select>
        </nz-form-item>
      </div>
      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.type')}}</nz-form-label>
          <hx-enum-select enumName="RecipeType" [enumType]="RecipeType" formControlName="type"></hx-enum-select>
        </nz-form-item>
      </div>
    </div>

    <nz-alert *ngIf="form.invalid" nzType="error" [nzMessage]="'error.fillRequiredFields' | transloco" nzShowIcon></nz-alert>

    <div nz-row [nzGutter]="8" class="cp_actions">
      <div nz-col>
        <nz-form-item>
          <nz-form-control>
            <button [nzLoading]="isSaving" [disabled]="form.pristine || form.pending" type="submit" nz-button nzType="primary">
              <i nz-icon nzType="save" nzTheme="outline"></i> {{'button.save' | transloco}}
            </button>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col>
        <nz-tag nzColor="success" *ngIf="form.pristine && model.id">
          <i nz-icon nzType="check-circle"></i>
          <span>{{'form.saved' | transloco}}</span>
        </nz-tag>
      </div>
    </div>
  </form>
</nz-skeleton>
